"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractManager = exports.EventType = void 0;
var events_1 = require("events");
var throwable_1 = __importDefault(require("../models/throwable"));
var EventType;
(function (EventType) {
    EventType["NEW_ERROR"] = "new-error";
})(EventType = exports.EventType || (exports.EventType = {}));
var AbstractManager = /** @class */ (function (_super) {
    __extends(AbstractManager, _super);
    function AbstractManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AbstractManager.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return _super.prototype.emit.apply(this, __spreadArrays([event], args));
    };
    AbstractManager.prototype.on = function (event, listener) {
        return _super.prototype.on.call(this, event, listener);
    };
    return AbstractManager;
}(events_1.EventEmitter));
exports.AbstractManager = AbstractManager;
var Manager = /** @class */ (function (_super) {
    __extends(Manager, _super);
    function Manager() {
        var _this = _super.call(this, { captureRejections: true }) || this;
        _this.errors = [];
        return _this;
    }
    Manager.prototype.run = function (fn) {
        try {
            return fn();
        }
        catch (e) {
            this.add(e);
            return undefined;
        }
    };
    Manager.prototype.runFuture = function (fn) {
        var _this = this;
        return fn().catch(function (e) {
            _this.add(e);
            return undefined;
        });
    };
    Manager.prototype.reset = function () {
        this.errors = [];
        return this;
    };
    Manager.prototype.hasDeadly = function () {
        return this.errors.some(function (v) {
            return v.deadly;
        });
    };
    Manager.prototype.formatted = function () {
        if (this.size > 0) {
            var msg = "Errors: \n";
            msg += this.errors.map(function (e) { return "  - " + e.toString(); });
            return msg;
        }
        else
            return "";
    };
    Object.defineProperty(Manager.prototype, "size", {
        get: function () {
            return this.errors.length;
        },
        enumerable: false,
        configurable: true
    });
    Manager.prototype.add = function (err) {
        var throwable = throwable_1.default.from(err);
        this.emit(EventType.NEW_ERROR, throwable);
        this.errors.push(throwable);
    };
    return Manager;
}(AbstractManager));
exports.default = Manager;
//# sourceMappingURL=manager.js.map